<div class="modal inmodal fade in parcel-modal parcel-history-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">Daily Entries on {{data.startDate | mccDate}}</h4>
            </div>
            <div class="modal-body">
                <div class="view-daily-report-header">
                    <div class="view-daily-report-row">
                        <div class="view-daily-report-header-top">Relieved</div>
                        <div class="view-daily-report-header-top">Relieved By</div>
                    </div>
                    <div class="view-daily-report-row">
                        <div class="view-daily-report-header-data">{{data.relieved}}</div>
                        <div class="view-daily-report-header-data">{{data.relievedBy}}</div>
                    </div>
                    <div class="view-daily-report-row" style="margin-top: 16px;">
                        <div class="view-daily-report-header-top">Date From</div>
                        <div class="view-daily-report-header-top">Date To</div>
                    </div>
                    <div class="view-daily-report-row">
                        <div class="view-daily-report-header-data">{{data.startDate | date:'yyyy-MM-dd hh:mma'}}</div>
                        <div class="view-daily-report-header-data">{{data.endDate | date:'yyyy-MM-dd hh:mma'}}</div>
                    </div>
                </div>
                <div class="timeline">
                    <spinner [spinnerShow]="showSpinner"></spinner>
                    <div *ngIf="entries.length > 0">
                        <ul class="timeline__list">
                            <li *ngFor="let e of entries">
                                <section>
                                    <header class="timeline__header">
                                        <span>
                                            <time>{{ e.createdAt | mccDate : true : true }}</time> - {{ e.createdBy ? e.createdBy.fullName : '-' }}
                                        </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div>
                                            {{ e.dateTo | date:'yyyy-MM-dd hh:mma'}}
                                        </div>
                                        <div>
                                            {{ e.details}}
                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="!entries.length && !showSpinner" class="no-history">
                        There are no history records about this Daily Report
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-view-report-modal/daily-reports-view-report-modal.component.html